/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placesusedunlimited2Inputs */

const en_placesusedunlimited2 = /** @type {(inputs: Placesusedunlimited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited Places`)
};

const de_placesusedunlimited2 = /** @type {(inputs: Placesusedunlimited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Orte`)
};

/**
* | output |
* | --- |
* | "Unlimited Places" |
*
* @param {Placesusedunlimited2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placesusedunlimited2 = /** @type {((inputs?: Placesusedunlimited2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placesusedunlimited2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placesusedunlimited2(inputs)
	return de_placesusedunlimited2(inputs)
});
export { placesusedunlimited2 as "placesUsedUnlimited" }